import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import isEmpty from "lodash/isEmpty";
import { PDPv4 } from "./PDPv4";
import { useCognitoUser } from "~/features/user/useCognitoUser";
import { ContentWrapper } from "~/features/contentWrapper";
import { PreLoaderByApplication } from "~/WhiteLabel/features";
import {
    trackHubSpotEvent,
    trackSegmentEvent,
    fetchTokenMetadata,
} from "~/api/choreography";
import { useV4TokenData } from "./useV4TokenData";
import {
    ArtworkEngagementEventTypes,
    EventNames,
} from "~/api/hubspot/hubspotEvents";
import { getUtms } from "~/api/hubspot/hubspot";
import { SegmentEvents } from "~/api/segment/segmentEvents";

export function PdpPage({
    blockchainId,
    tokenId,
    tokenContractAddress,
    isPDPV4Enabled,
}: {
    blockchainId: number;
    tokenId: number;
    tokenContractAddress: string;
    isPDPV4Enabled?: boolean;
}) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            fetchTokenMetadata({
                tokenId,
                blockchainId,
                tokenContractAddress,
            }),
        );
    }, [dispatch, tokenId, blockchainId, tokenContractAddress]);

    const user = useCognitoUser();
    const tokenData = useV4TokenData();
    const tokenDataIsLoaded = tokenData && !isEmpty(tokenData);
    useEffect(() => {
        if (tokenDataIsLoaded) {
            dispatch(
                trackHubSpotEvent({
                    eventName: EventNames.artwork_engagement,
                    email: user?.email,
                    properties: {
                        user_id: user?.externalId,
                        action_type: ArtworkEngagementEventTypes.artwork_viewed,
                        page_path: globalThis?.location?.pathname,
                        page_title: globalThis?.document.title,
                        page_url: globalThis?.location?.href,
                        artwork_id: tokenId,
                        artwork_name: tokenData?.contractName,
                        artwork_type:
                            tokenData?.metadata?.properties.tokenType
                                ?.description,
                        ...getUtms(),
                    },
                }),
            );
            dispatch(
                trackSegmentEvent({
                    eventName: SegmentEvents.ARTWORKS_PAGE_VIEWED,
                    properties: {
                        user_id: user?.externalId,
                        email: user?.email,
                        artwork_id: tokenId,
                        artwork_name: tokenData?.metadata?.name,
                        artwork_type:
                            tokenData?.metadata?.properties.tokenType
                                ?.description,
                        artist_name:
                            tokenData?.metadata?.properties.artistName
                                ?.description,
                    },
                }),
            );
        }
    }, [blockchainId, dispatch, tokenDataIsLoaded, tokenData, tokenId, user]);

    if (!tokenDataIsLoaded) {
        return (
            <ContentWrapper>
                <PreLoaderByApplication />
            </ContentWrapper>
        );
    }

    return <PDPv4 tokenData={tokenData} isPDPV4Enabled={isPDPV4Enabled} />;
}
